import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Clientes</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Clientes</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Novo", -1)
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "cnpj" }, [
  /*#__PURE__*/_createTextVNode("CNPJ "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_13 = { class: "form-group col-12 col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, [
  /*#__PURE__*/_createTextVNode("Tipo "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecione", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-group col-12 col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "company" }, [
  /*#__PURE__*/_createTextVNode("Razão social "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "trade_name" }, [
  /*#__PURE__*/_createTextVNode("Nome fantasia "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_21 = { class: "form-group col-12 col-md-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "inscricao_estadual" }, "Inscrição estadual", -1)
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "inscricao_municipal" }, "Inscrição municipal", -1)
const _hoisted_25 = { class: "form-group col-12 col-md-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "segment" }, [
  /*#__PURE__*/_createTextVNode("Segmento "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecione", -1)
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-group col-12 col-md-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "economic_sector" }, [
  /*#__PURE__*/_createTextVNode("Setor econômico "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Selecione", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "form-group col-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "partner" }, "Parceiro", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { class: "form-group col-12 col-md-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "zip_code" }, [
  /*#__PURE__*/_createTextVNode("CEP "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_38 = { class: "form-group col-12 col-md-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "street_name" }, [
  /*#__PURE__*/_createTextVNode("Endereço "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_40 = { class: "form-group col-12 col-md-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "complement" }, "Complemento", -1)
const _hoisted_42 = { class: "form-group col-12 col-md-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "district" }, [
  /*#__PURE__*/_createTextVNode("Bairro "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_44 = { class: "form-group col-12 col-md-6" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "state" }, [
  /*#__PURE__*/_createTextVNode("UF "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<option value=\"AC\">AC</option><option value=\"AL\">AL</option><option value=\"AM\">AM</option><option value=\"AP\">AP</option><option value=\"BA\">BA</option><option value=\"CE\">CE</option><option value=\"DF\">DF</option><option value=\"ES\">ES</option><option value=\"GO\">GO</option><option value=\"MA\">MA</option><option value=\"MG\">MG</option><option value=\"MS\">MS</option><option value=\"MT\">MT</option><option value=\"PA\">PA</option><option value=\"PB\">PB</option><option value=\"PE\">PE</option><option value=\"PI\">PI</option><option value=\"PR\">PR</option><option value=\"RJ\">RJ</option><option value=\"RN\">RN</option><option value=\"RO\">RO</option><option value=\"RR\">RR</option><option value=\"RS\">RS</option><option value=\"SC\">SC</option><option value=\"SE\">SE</option><option value=\"SP\">SP</option><option value=\"TO\">TO</option>", 27)
const _hoisted_73 = [
  _hoisted_46
]
const _hoisted_74 = { class: "form-group col-12 col-md-6" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { for: "city" }, [
  /*#__PURE__*/_createTextVNode("Cidade "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_76 = { class: "form-group col-12" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Observações", -1)
const _hoisted_78 = { class: "card-footer text-center" }
const _hoisted_79 = { class: "btn-group" }

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                id: "cnpj",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.cnpj) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.cnpj }]),
                style: {"max-width":"200px"},
                onInput: _cache[2] || (_cache[2] = $event => (_ctx.isCNPJ()))
              }, null, 34), [
                [_vModelText, _ctx.row.cnpj],
                [_directive_maska, '##.###.###/####-##']
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.cnpj), 513), [
                [_vShow, _ctx.errors.cnpj != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("select", {
                id: "type",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.row.type) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.type }])
              }, [
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyTypes, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_16))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.type]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.type), 513), [
                [_vShow, _ctx.errors.type != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                id: "company",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.row.company) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.company }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.company]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.company), 513), [
                [_vShow, _ctx.errors.company != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                id: "trade_name",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.row.trade_name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.trade_name }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.trade_name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.trade_name), 513), [
                [_vShow, _ctx.errors.trade_name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                id: "inscricao_estadual",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.row.inscricao_estadual) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.inscricao_estadual }]),
                style: {"max-width":"200px"},
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.inscricao_estadual]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.inscricao_estadual), 513), [
                [_vShow, _ctx.errors.inscricao_estadual != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                id: "inscricao_municipal",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.row.inscricao_municipal) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.inscricao_municipal }]),
                style: {"max-width":"200px"},
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.inscricao_municipal]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.inscricao_municipal), 513), [
                [_vShow, _ctx.errors.inscricao_municipal != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("select", {
                id: "segment",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.row.segment) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.segment }])
              }, [
                _hoisted_27,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companySegments, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_28))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.segment]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.segment), 513), [
                [_vShow, _ctx.errors.segment != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("select", {
                id: "economic_sector",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.row.economic_sector) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.economic_sector }])
              }, [
                _hoisted_31,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.economicSectors, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_32))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.economic_sector]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.economic_sector), 513), [
                [_vShow, _ctx.errors.economic_sector != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _hoisted_35,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.partner,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.row.partner) = $event)),
                "on-label": "Sim",
                "off-label": "Não",
                class: "toggle-partner"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                id: "zip_code",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.row.zip_code) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.zip_code }]),
                style: {"max-width":"150px"},
                onKeyup: _cache[12] || (_cache[12] = $event => (_ctx.findCEP()))
              }, null, 34), [
                [_vModelText, _ctx.row.zip_code],
                [_directive_maska, '##.###-####']
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.zip_code), 513), [
                [_vShow, _ctx.errors.zip_code != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                id: "street_name",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.row.street_name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.street_name }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.street_name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.street_name), 513), [
                [_vShow, _ctx.errors.street_name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                id: "complement",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.row.complement) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.complement }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.complement]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.complement), 513), [
                [_vShow, _ctx.errors.complement != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _withDirectives(_createElementVNode("input", {
                id: "district",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.row.district) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.district }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.district]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.district), 513), [
                [_vShow, _ctx.errors.district != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _withDirectives(_createElementVNode("select", {
                id: "state",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.row.state) = $event)),
                style: {"width":"auto"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.state }])
              }, _hoisted_73, 2), [
                [_vModelSelect, _ctx.row.state]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.state), 513), [
                [_vShow, _ctx.errors.state != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _hoisted_75,
              _withDirectives(_createElementVNode("input", {
                id: "city",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.row.city) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.city }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.city]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.city), 513), [
                [_vShow, _ctx.errors.city != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _hoisted_77,
              _withDirectives(_createElementVNode("textarea", {
                id: "description",
                rows: "4",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.row.description) = $event)),
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.description }])
              }, null, 2), [
                [_vModelText, _ctx.row.description]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.description), 513), [
                [_vShow, _ctx.errors.description != null]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-warning",
                onClick: _cache[19] || (_cache[19] = $event => (_ctx.goBack()))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-success",
                onClick: _cache[20] || (_cache[20] = $event => (_ctx.save()))
              }, "Gravar")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}